module.exports = __webpack_public_path__ + "img/bosses-minigrip.23572f88.jpg";